import React from "react";
import {createLinkClickHandler} from "../handlers/linkClickHandler";

export type UseLinkTrackingParams = {
    href: string | null | undefined;
    target?: "_self" | "_blank";
    onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
    isExternalOverride?: boolean;
    delayMs?: number;
    elementLocation?: string;
    pushOptions?: import("../core/types").PushOptions;
    contentLabel?: string,
};

/**
 * useLinkTracking
 * Returns a memoized onClick handler that delegates to the centralized handler.
 * The handler will execute the consumer onClick first and then determine the
 * active interaction id at click time to join the correct event group.
 */
export function useLinkTracking(params: UseLinkTrackingParams) {
    return React.useMemo(
        () =>
            createLinkClickHandler({
                href: params.href,
                linkTarget: params.target ?? "_self",
                onClick: params.onClick,
                isExternalOverride: params.isExternalOverride,
                delayMs: params.delayMs,
                pushOptions: params.pushOptions,
                elementLocation: params.elementLocation,
                contentLabel: params.contentLabel,

            }),
        [
            params.href,
            params.target,
            params.onClick,
            params.isExternalOverride,
            params.delayMs,
            params.elementLocation,
            params.pushOptions,
            params.contentLabel
        ]
    );
}
